<div
  class="one3d-feedback-wrapper"
  *ngIf="!formSubmitOrSkipped && !fetchingFeedbackDetails"
>
  <div class="one3d-feedback-internal">
    <!-- <div class="one3d-cross-icon" (click)="close(currentIndex + 1)">
      <img src="assets/img/icons/one3d-crossblack-icon.svg" alt="" />
    </div> -->
    <div class="one3d-logo">
      <img src="assets/img/icons/one3d-jeep-black-logo.svg" alt="Jeep-logo" />
    </div>
    <div class="one3d-text">
      <p>
        <!-- {{ feedbackObj[currentIndex].description }} -->
        Apologies for the interruption, your feedback is valuable.
      </p>
    </div>
    <div class="one3d-bottom-content">
      <div class="one3d-bottom-content-row" *ngFor="let item of feedbackObj">
        <div class="one3d-bottom-content-left">
          <p class="one3d-bottom-content-text">
            {{item?.question_name}}
          </p> 
        </div>
        <div class="one3d-bottom-content-right">
          <div class="one3d-thumb-buttons">
            <button
              class="one3d-thumb-up" 
              [ngClass]="{'selected-thumb' : selectedOption[item.question_id] == 'up'}"
              (click)="nextSlide('up', item)"
            > 
              <img
                class=""
                src="assets/img/icons/one3d-thumbsup-icon.svg"
                alt="thumbs up green icon"
              />
            </button>
            <button
              class="one3d-thumb-down"
              [ngClass]="{'selected-thumb' : selectedOption[item.question_id] == 'down'}"
              (click)="nextSlide('down', item)"
            > 
              <img
                src="assets/img/icons/one3d-thumbsdown-green.svg"
                alt="thumbs down green icon"
              />
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="one3d-bottom-box-new">
      <div class="one3d-bottom-box-in">
        <p class="one3d-bottom-box-para">
          We’re committed to improve your experience & welcome any suggestions!
        </p>
        <div class="one3d-bottom-textarea-box">
          <textarea [(ngModel)]="comment" placeholder="Eg. I would like to see..."  class="one3d-bottom-textarea"></textarea>
        </div>
        <div class="one3d-bottom-buttons-group">
          <div class="one3d-skip-submit-buttons-group">
            <button class="one3d-skip-button" (click)="close()">SKIP</button>
            <button class="one3d-submit-button" (click)="submit()">SUBMIT</button>
          </div>
        </div>
      </div>
    </div>
    <div style="display: none;" class="one3d-bottom-skip ion-text-center" (click)="close()">
        <ion-text class="one3d-bottom-skip-text">SKIP</ion-text>
    </div>
    <div class="one3d-bottom-content" style="display: none;">
      <div class="one3d-slide-list">
        <span class="one3d-popup-list">{{ currentIndex + 1 }}.</span>
        <h4 class="one3d-keyFeatures-model-title">
          {{ feedbackObj?.[currentIndex]?.question_name }}
        </h4>
      </div>
      <div class="one3d-thumb-buttons">
        <button
          class="one3d-thumb-up"
          (click)="nextSlide('up', feedbackObj[currentIndex])"
        > 
          <img
            class=""
            src="assets/img/icons/one3d-thumbsup-icon.svg"
            alt="thumbs up green icon"
          />
        </button>
        <button
          class="one3d-thumb-down"
          (click)="nextSlide('down', feedbackObj[currentIndex])"
        > 
          <img
            src="assets/img/icons/one3d-thumbsdown-green.svg"
            alt="thumbs down green icon"
          />
        </button>
      </div>
      <div class="one3d-keyFeatures-controls">
        <ion-row class="one3d-ef-bottom ion-justify-content-between">
          <ion-col
            class="ion-justify-content-center ion-align-items-center one-3d-flex"
          >
            <span
              *ngFor="let feedback of feedbackObj; let i = index"
              class="one3d-dot"
              [ngClass]="{
                'one3d-active': i == currentIndex
              }"
            ></span>
          </ion-col>
        </ion-row>
      </div>
    </div>
  </div>
</div>
<div class="one3d-feedback-wrapper" *ngIf="fetchingFeedbackDetails">
    <div class="one3d-feedback-internal">
      <div class="one3d-logo">
        <img src="assets/img/icons/one3d-jeep-black-logo.svg" alt="Jeep-logo" />
      </div>
      <div class="one3d-text" style="margin-top: 25px">
        <p>Fetching Feedback Details...</p>
      </div>
    </div>
</div>
<!-- feedback-successful -->
<!-- *ngIf="currentIndex == feedbackObj.length && !fetchingFeedbackDetails" -->
<div
  class="one3d-feedback-wrapper" *ngIf="formSubmitOrSkipped"
>
  <div class="one3d-feedback-internal">
    <div class="one3d-cross-icon" (click)="close()">
      <img src="assets/img/icons/one3d-crossblack-icon.svg" alt="" />
    </div>
    <div class="one3d-envelope-icon">
      <img src="assets/img/icons/one3d-envelop-icon.svg" alt="envelop-icon" />
    </div>
    <div class="one3d-regard-feedback">
      <h4>Thank you for your feedback!</h4>
      <p>
        Thankyou for steering us in the right direction. Your feedback fuels the
        evolution of our digital car experience!
      </p>
    </div>
    <!-- <div class="one3d-logo-bottom">
      <img src="assets/img/icons/one3d-jeep-green-logo.svg" alt="Jeep-logo" />
    </div> -->
  </div>
</div>
